import React, { useState } from "react";
import "./drawerComponent.scss";
import { Drawer } from "@mui/material";
import CloseIcon from "../../assets/close_icon.png";
import DocumentContainer from "../UI Component/DocumentViewer/DocumentCotainer";
import ViewDocuments from "../ViewDocuments";
import close_icon from "../../assets/crossIcon.svg";
import PrescriptionTabComponent from "../PrescriptionTabComponent";
import { DEV, QA } from "../common/config";

const DrawerComponent = (props) => {
  const {
    drawerOpen,
    toggleDrawer,
    appointmentForDrawer,
    ageForDrawer,
    drawerType,
    fetchPastAppointmentDataList,
    appointmentDetails,
  } = props;

  const [documentShow, setDocumentShow] = useState(false);

  const [fileUrl, setFileUrl] = useState("");
  const [fileName, setFileName] = useState("");
  const [fileType, setFileType] = useState("");
  const [fullView, setFullView] = useState(false);
  const [drowerPostionInitianlView, setDrowerPostionInitianlView] =
    useState(false);

  const showAbhaHealthRecord =
    appointmentDetails?.abha_address_kyc_verified &&
    appointmentDetails?.abdm_hfr_id &&
    (process.env.REACT_APP_ENV === DEV ||
      process.env.REACT_APP_ENV === QA ||
      window.location.hostname === "localhost");

  const renderDocument = (width) => {
    if (documentShow) {
      return (
        <DocumentContainer
          cancelHandler={closeNotification}
          fullViewHandler={() => {
            setFullView(!fullView);
          }}
          url={fileUrl}
          fileName={fileName}
          fileType={fileType}
          width={width || ""}
        />
      );
    }
  };

  const viewDocument = (fileURL, fileName, fileType, prescription) => {
    if (fileType && fileType.match(/pdf/gim) && !prescription) {
      downloadURI(fileURL, fileName);
    } else {
      setDocumentShow(true);
      setFileUrl(fileURL);
      setFileName(fileName);
      setFileType(fileType);
    }
  };

  const closeNotification = () => {
    setDocumentShow(false);
    setFileUrl("");
    setFileName("");
    setFileType("");
    setFullView(false);
  };

  const downloadURI = (uri, name) => {
    let link = document.createElement("a");
    link.href = uri;
    link.target = "_blank";
    link.click();
  };

  const displayViewDocumentHeader = () => {
    return (
      <div className="view-documents-modal-header">
        <div className="view-documents-modal-header-title">Documents</div>
        <div
          className="view-documents-modal-header-close"
          onClick={toggleDrawer}
        >
          <img src={close_icon} alt="" />
        </div>
      </div>
    );
  };

  return (
    <Drawer
      anchor={"right"}
      open={drawerOpen}
      className={`${drowerPostionInitianlView ? "drawer_component" : ""}`}
      PaperProps={{
        sx: {
          width: window.innerWidth < 767 ? "100%" : "auto",
          overflow: "hidden",
        },
      }}
    >
      <div>
        {drawerType === "View Documents" || drawerType === "Documents" ? (
          <div
            className={` view-documents-modal ${
              showAbhaHealthRecord
                ? "view-documents-modal-width"
                : "view-documents-modal-width-sec"
            } `}
          >
            {displayViewDocumentHeader()}
            <ViewDocuments
              appointmentData={appointmentForDrawer}
              documentShow={documentShow}
              showAbhaHealthRecord={showAbhaHealthRecord}
              handleViewDocument={viewDocument}
              appointmentDetails={appointmentDetails}
            >
              {renderDocument("98%")}
            </ViewDocuments>
          </div>
        ) : (
          (drawerType === "Edit Prescription" ||
            drawerType === "Create Prescription" ||
            drawerType === "Upload Prescription" ||
            drawerType === "Manage Prescription") && (
            <div className="py-3  px-2 px-md-2 prescription-drawer">
              {/* previous-patients-prescription-edit-drawer */}
              <div className="container pl-0 pr-2">
                <h2 className="px-3">
                  {"Prescription"}
                  <span
                    className="float-right cursor-pointer mt-2"
                    onClick={toggleDrawer}
                    style={{ fontSize: "1rem" }}
                  >
                    <img src={CloseIcon} alt="Close" />
                  </span>
                </h2>
              </div>
              <PrescriptionTabComponent
                drawerType={drawerType}
                appointmentData={appointmentForDrawer}
                age={ageForDrawer}
                closeDrawer={toggleDrawer}
                fetchPastAppointmentDataList={fetchPastAppointmentDataList}
                setDrowerPostionInitianlView={setDrowerPostionInitianlView}
              />
            </div>
          )
        )}
      </div>
    </Drawer>
  );
};

export default DrawerComponent;
